<template>
<div>
    <div class="form-group">
        <label>Gebruikersnaam <span class="text-danger">*</span></label>
        <input
        :value="user.UserName"
        class="form-control"
        type="text"
        disabled
        name="username">
    </div>
    <div class="form-group">
        <label>Email <span class="text-danger">*</span></label>
        <input
        v-model="user.Email"
        class="form-control"
        type="email"
        disabled
        name="email">
    </div>
    <div class="form-group">
        <label>Organisatie <span class="text-danger">*</span></label>
        <input
        v-model="user.CompanyName"
        required
        class="form-control"
        type="text"
        name="CompanyName">
    </div>
    <div v-if="user.ContactID">
        <div class="form-group">
            <label>Initialen <span class="text-danger">*</span></label>
            <select
            v-model="user.Salutation"
            class="form-control col-2"
            name="initials"
            autocomplete="initials">
                <option value="Mr">Dhr.</option>
                <option value="Mrs">Mvr.</option>
            </select>
        </div>
        <div class="form-group">
            <label>Voornaam <span class="text-danger">*</span></label>
            <input
            v-model="user.FirstName"
            required
            class="form-control"
            type="text"
            name="firstName">
        </div>
        <div class="form-group">
            <label>Achternaam <span class="text-danger">*</span></label>
            <input
            v-model="user.LastName"
            required
            class="form-control"
            type="text"
            name="lastName">
        </div>
        <div class="form-group">
            <label>Ondernemings- of rijksregisternummer <span class="text-danger">*</span></label>
            <input
            v-model="number"
            required
            class="form-control"
            type="text"
            name="lastName">
        </div>

        <div class="form-group">
            <label>Telefoonnummer</label>
            <input
            v-model="user.Tel"
            class="form-control"
            type="text"
            name="tel">
        </div>
        <div class="form-group">
            <label>Plaats</label>
            <input
            v-model="user.City"
            class="form-control"
            type="text"
            name="city">
        </div>
        <div class="form-group">
            <label>Postcode</label>
            <input
            v-model="user.ZipCode"
            class="form-control"
            type="text"
            name="zipcode">
        </div>
        <div class="form-group">
            <label>Straat</label>
            <input
            v-model="user.Street"
            class="form-control"
            type="text"
            name="street">
        </div>
        <div class="form-group">
            <label>Huisnummer</label>
            <input
            v-model="user.HouseNumber"
            class="form-control"
            type="text"
            name="houseNumber">
        </div>
        <div class="form-group">
            <label>Toevoeging</label>
            <input
            v-model="user.HouseNumberAddition"
            class="form-control"
            type="text"
            name="houseNumberAddition">
        </div>
        <hr>
        <passwordfield
        v-model="newPassword"
        name="Nieuw wachtwoord"/>
        <div class="form-group">
            <label>Herhaal wachtwoord </label>
            <input
            v-model="confirmPassword"
            :class="validateConfirPassword"
            class="form-control"
            type="password"
            name="confirmPassword"
            autocomplete="new-password">
        </div>
        <button
        class="btn btn-secondary"
        @click="changeUserDetails()">
            Gegevens bijwerken
        </button>
    </div>
    <div v-if="!user.ContactID">
        <p>Je bent ingelogd als een BorrowMe gebruiker. Je kunt je gegevens wijzigen in <a href="https://uitleendiensterfgoed.borrowme.net">BorrowMe</a>.</p>
    </div>
</div>
</template>

<script>
import passwordfield from '../Global/Passwordfield'
import CustomerService from '@/services/CustomerService.js'

export default {
    components: {
        passwordfield
    },
    data () {
        return {
            /* getting the user from the store in a local object because we want to be able to manipulate it
            and if the PATCH call is succesfull, we'll get the updated details back which we will commit to the store. */
            number: '',
            numberLabel: 'Ondernemingsnummer',
            user: {},
            newPassword: '',
            confirmPassword: ''
        }
    },
    computed: {
        validateConfirPassword: function () {
            if (this.confirmPassword.length > 0) {
                return this.newPassword === this.confirmPassword ? 'is-valid' : 'is-invalid'
            } else {
                return ''
            }
        }
    },
    created () {
        this.getUser()
    },
    methods: {
        getUser () {
            this.user = this.$store.getters.user
            delete this.user.Token
            if (this.user.ECCUST_Ondernemingsnummer) {
                this.number = this.user.ECCUST_Ondernemingsnummer
                // Ondernemingsnummer / Rijksregisternummer
            } else {
                this.number = ''
            }
            this.number = this.user.ECCUST_Ondernemingsnummer ? this.user.ECCUST_Ondernemingsnummer : this.user.ECCUST_Rijksregisternummer
            this.numberLabel = this.user.ECCUST_Ondernemingsnummer ? 'Ondernemingsnummer' : 'Rijksregisternummer'
        },
        async changeUserDetails () {
            if (this.newPassword && this.confirmPassword) {
                this.user.Password = this.newPassword
                this.user.ConfirmPassword = this.confirmPassword
            }
            if (this.numberLabel === 'Ondernemingsnummer') {
                this.user.ECCUST_Ondernemingsnummer = this.number
            } else {
                this.user.ECCUST_Rijksregisternummer = this.number
            }
            await CustomerService.updateCustomerDetails(this.user)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/UserDetails.vue